import SnackbarMount, { SnackbarMountProps } from "./SnackbarMount";

function SnackbarOnAction({ duration, ...props }: Omit<SnackbarMountProps, "variant">) {
  return (
    <SnackbarMount
      {...props}
      duration={duration}
      variant="info"
    />
  );
}

export default SnackbarOnAction;
